import { render, staticRenderFns } from "./buffet.vue?vue&type=template&id=067ad424&"
import script from "./buffet.vue?vue&type=script&lang=js&"
export * from "./buffet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports